import React from "react";
import { useNavigate, Link } from "react-router-dom";

export default function EmailSent() {
  const navigate = useNavigate();

  return (
    <div className="onboarding-container">
      <div className="onboard-content flex-grow-1">
        <div className="admin-sign-in">
          <h4
            style={{
              textAlign: "center",
              color: "rgba(230, 236, 241, 1)",
              fontFamily: "Poppins",
              fontSize: "20px",
              lineHeight: "30px",
              fontWeight: 600,
            }}
          >
            Reset Link Sent
          </h4>
          <h4
            style={{
              marginBottom: "40px",
              textAlign: "center",
              color: "rgba(230, 236, 241, 1)",
              fontFamily: "Poppins",
              fontSize: "16px",
              lineHeight: "30px",
              fontWeight: 300,
            }}
          >
            Your password reset link has been sent to your email, check your
            inbox.
          </h4>

          <div
            className="d-flex justify-content-center w-100"
            style={{ marginTop: "40px" }}
          >
            <button
              type="button"
              onClick={() => navigate("/login")}
              style={{ maxWidth: "160px", width: "100%" }}
              className="btn-1 btn-1-basic"
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
